export default "__VITE_ASSET__z2dUm$aD__"